import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'


const columns = [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date'
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        key: 'amount',
    },
    {
        title: 'Origin',
        dataIndex: 'origin',
        key: 'origin',
    },
    {
      title: 'Destination',
      dataIndex: 'destination',
      key: 'destination',
    },
    {
        title: 'Driver Name',
        dataIndex: 'clientName',
        key: 'clientName',
    },

  ];

  const data = [
    {
      key: '1',
      date: 'Sep 12, 2019',
      amount: '15,000',
      origin: 'Kampala',
      destination: 'Mbarara',
      clientName: 'Katusiime Rosette',
    },
    {
        key: '2',
        date: 'Sep 13, 2019',
        amount: '15,000',
        origin: 'Mbarara',
        destination: 'Rukungiri',
        clientName: 'Tumwijukye Ambrose',
      },
  ];

class Payouts extends Component {

    render() {
        return (
            <div>
                <h1>Payouts</h1>

                <Table columns={columns} dataSource={data} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.token !== null
    }
}

export default connect(mapStateToProps, null)(Payouts);

